import { render, staticRenderFns } from "./ScanTags.vue?vue&type=template&id=51d000bc"
import script from "./ScanTags.vue?vue&type=script&lang=js"
export * from "./ScanTags.vue?vue&type=script&lang=js"
import style0 from "./ScanTags.vue?vue&type=style&index=0&id=51d000bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports